export const popup = () => {
    const popup = document.getElementById('contact__popup');
    if (!popup) {
        return;
    }

    const closeBtn = document.querySelector('.contact__popup-close');
    const trigger = document.querySelector('.contact__disclaimer');

    const openPopup = (event) => {
        event.preventDefault();
        popup.style.display = 'block';
    };

    const closePopup = () => {
        popup.style.display = 'none';
    };

    trigger.addEventListener('click', openPopup);

    closeBtn.addEventListener('click', closePopup);

    window.addEventListener('click', (event) => {
        if (event.target === popup) {
            closePopup();
        }
    });
};